'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stringify = function stringify(value) {
  return (0, _isObject2.default)(value) || (0, _isArray2.default)(value) ? JSON.stringify(value) : value;
};
exports.default = stringify;
//# sourceMappingURL=stringify.js.map